import { apolloClient } from '../apolloClient'
import { GET_USER_SALE_CONTRACTS } from './queries/GET_USER_SALE_CONTRACTS'
import { listUserSaleContracts } from '../types/listUserSaleContracts'
import { setGlobal } from '../../global/useGlobal'

export const getUserSaleContracts = async () => {
  const response = await apolloClient.query<listUserSaleContracts>({
    query: GET_USER_SALE_CONTRACTS,
  })

  const dropdownList = () => {
    return response.data?.listUserSaleContracts?.map((item, index) => {
      return {
        id: index,
        text: `${item.construction.name} - ${item.constructionUnit.name}`,
      }
    })
  }

  if (response) {
    await setGlobal({
      userSaleContracts: response.data?.listUserSaleContracts,
      dropdownUserSaleContractsData: dropdownList(),
    })
  }

  return response.data
}
